<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Among the Fair Magnolias: Four Southern Love Stories</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="txca" id="pz10-1"><a id="page_2">
<i>For My Mother</i> </a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication01.vue?2b3fd5d2